<template>
  <div class="acoj-render" v-loading.fullscreen.lock="uploadLoading">
    <div class="header-wrap" v-if="normalizedProblem">{{ normalizedProblem.problem_no }}.&nbsp;{{ normalizedProblem.title }}</div>
    <div class="main-con">
      <div class="side-wrap">
        <el-tabs v-model="activeName">
          <el-tab-pane name="1">
            <span slot="label"><i class="iconfont icon-subject"></i>&nbsp;题目详情</span>
            <div class="subject-con" ref="subjectTabs" v-if="normalizedProblem">
              <div class="subject-title latex-format" v-html="normalizedProblem.content"></div>
              <div
                v-if="normalizedProblem.problem_attach && normalizedProblem.problem_attach.length > 0"
                style="margin-bottom: 10px;"
                class="subject-item"
              >
                <p><b>附件：</b></p>
                <div class="subject-item-attach">
                  <div v-for="(item, index) in normalizedProblem.problem_attach" :key="index">
                    <span>{{ item.attach_name }}</span>
                    <el-button
                      style="float: right;font-size: 0.8rem;color: #30FF57;"
                      type="text"
                      @click="downloadAIHomework(item.download_path, normalizedProblem.problem_no + normalizedProblem.title + '-' + item.attach_name)"
                    >立即下载</el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="editor-wrap">
        <div class="editor-wrap-box" style="font-size: 1.2rem;" v-if="!normalizedResult">暂未提交答案</div>
        <div style="flex-direction: column" class="editor-wrap-box" v-else-if="!normalizedResult.show_url">
          <div class="request-loading-error"></div>
          <div style="margin-top: 2rem">文件数据过大，无法在线预览</div>
        </div>
        <div class="editor-wrap-box">
          <div class="btn-area">
            <div class="upload-wrap">
              <el-upload
                  v-if="canUpload"
                  :action="uploadAction"
                  name="file"
                  :headers="{ authorization: this.$store.getters.token }"
                  :before-upload="handleBefore"
                  :on-success="handleSuccess"
                  :file-list="fileList"
                  :show-file-list="false"
                  :limit="1"
                  :loading="uploadLoading"
                  :data="uploadData"
                  style="color: white;font-size: 1.3rem;"
                  class="btn-item btn-active"
              >上传文件</el-upload>
              <div v-else class="btn-item btn-inactive">上传文件</div>
              <div class="upload-tip">上传文件后将自动提交题目</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "competitionAiRender",
  props: {
    problemInfo: {
      type: Object,
      default: null
    },
    userResult: {
      type: Object,
      default: null
    },
    uploadAction: {
      type: String,
      default: ''
    },
    uploadData: {
      type: Object,
      default: () => ({})
    },
    uploadEnabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeName: "1",
      uploadLoading: false,
      fileList: []
    }
  },
  computed: {
    normalizedProblem() {
      if (!this.problemInfo) {
        return null
      }
      return this.problemInfo.problem || this.problemInfo
    },
    normalizedResult() {
      if (!this.userResult) {
        return null
      }
      return this.userResult.result || this.userResult
    },
    canUpload() {
      return this.uploadEnabled && !!this.uploadAction
    }
  },
  watch: {
    problemInfo() {
      this.activeName = "1"
      this.$nextTick(() => {
        if (this.$refs.subjectTabs) {
          this.$refs.subjectTabs.scrollTo({
            top: 0,
          });
        }
      })
    }
  },
  methods: {
    handleSuccess(response) {
      this.uploadLoading = false
      this.fileList = []
      if (response.status === 1) {
        const uploadUrl = this.getUploadUrl(response.data)
        this.$emit('commitResult', {
          codeContent: uploadUrl,
          language: 0,
          result: uploadUrl,
          userResult: this.normalizeUploadResult(response.data, uploadUrl)
        })
      } else {
        this.$message({
          type: 'error',
          message: response.message
        })
      }
    },
    handleBefore() {
      this.uploadLoading = true
    },
    getUploadUrl(data) {
      if (!data) {
        return ''
      }
      if (typeof data === 'string') {
        return data
      }
      return data.url || data.show_url || data.download_url || data.path || data.file_path || ''
    },
    normalizeUploadResult(data, uploadUrl) {
      if (data && typeof data === 'object') {
        return {
          show_url: data.show_url || uploadUrl,
          download_url: data.download_url || uploadUrl,
          show_type: data.show_type || this.getFileType(uploadUrl),
          url: uploadUrl
        }
      }
      return {
        show_url: uploadUrl,
        download_url: uploadUrl,
        show_type: this.getFileType(uploadUrl),
        url: uploadUrl
      }
    },
    getFileType(url) {
      if (!url || typeof url !== 'string') {
        return ''
      }
      const cleanUrl = url.split('?')[0]
      const parts = cleanUrl.split('.')
      return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : ''
    },
    downloadAIHomework(url, fileName = null) {
      if (!url) {
        return
      }
      if (this.$isElectron() && fileName) {
        const { ipcRenderer } = require("electron");
        ipcRenderer.send('download', {
          downloadPath: url,
          fileName: fileName
        })
      } else {
        const link = document.createElement('a')
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = url
        link.download = fileName || 'download'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      }
    },
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      return year + month + day;
    }
  }
}
</script>

<style lang="scss" scoped>
.acoj-render {
  color: #FFF;
  height: 100%;

  .header-wrap {
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .main-con {
    display: flex;
    padding: 0 0 0 10px;
    font-size: 1rem;
    height: calc(100% - 39px);

    p {
      margin: 0 0 10px 0;
    }

    pre {
      margin: 0 0 10px 0;
      background: #1D4E64;
      color: #BCF3FF;
      border-radius: 6px;
      padding: 20px 20px;
      white-space: inherit;
      word-wrap: break-word;
      line-height: 2;
      font-family: Courier,Source Han Sans SC !important;
    }

    .side-wrap {
      width: 50%;
      margin-right: 20px;

      .subject-con {
        padding-right: 10px;

        .subject-title {
          padding: 0 0 20px 0;
          line-height: 2 !important;
          font-size: 1rem;
          font-family: Courier,Source Han Sans SC !important;
          color: white !important;

          ::v-deep p {
            line-height: 2 !important;
            font-size: 1rem !important;
            font-family: Courier,Source Han Sans SC !important;
            color: white !important;

            span {
              line-height: 2 !important;
              font-size: 1rem !important;
              font-family: Courier,Source Han Sans SC !important;
              color: white !important;
            }
          }
        }

        .subject-item {
          margin-left: 10px;
          line-height: 2 !important;
          font-size: 1rem !important;
          font-family: Courier,Source Han Sans SC !important;

          .subject-item-attach {
            padding: 10px;
            background-color: #142029;
            border-radius: 2px;
            color: #BCF3FF;
            border: 1px solid #0FBFB0;
          }

          ::v-deep b {
            color: #ffffff !important;
          }

          ::v-deep p {
            color: #BCF3FF !important;
            line-height: 2 !important;
            font-size: 1rem !important;
            font-family: Courier,Source Han Sans SC !important;

            span {
              color: #BCF3FF !important;
              line-height: 2 !important;
              font-size: 1rem !important;
              font-family: Courier,Source Han Sans SC !important;
            }
          }
        }
      }

      ::v-deep .el-tabs {
        height: 100%;

        .el-tabs__item.is-active {
          font-size: 1rem;

          i {
            font-size: 1rem;
          }
        }

        .el-tabs__item {
          font-size: 0.7rem;

          i {
            font-size: 0.7rem;
          }
        }

        .el-tabs__content {
          height: 100%;
          overflow: auto;

          .el-tab-pane {
            height: 100%;

            .subject-con {
              height: 100%;
              overflow: auto;
            }
          }
        }
      }
    }

    .editor-wrap {
      width: 50%;
      height: calc(100vh - 8rem);
      background: rgba(23, 33, 38, 0.8);
      border: 2px solid #7CFFF4;
      border-radius: 20px;
      display: flex;
      flex-direction: column;

      .editor-wrap-box {
        flex: 1;
        min-height: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .show-user-result {
          width: 100%;
          height: 93%;
          overflow-y: scroll;
          margin: 20px;

          ::v-deep img {
            max-width: 98%;
            max-height: 99%;
          }

          ::v-deep video {
            max-width: 98%;
            max-height: 99%;
          }

          ::v-deep p,
          ::v-deep span {
            font-size: 1rem;
          }
        }

        .show-user-result::-webkit-scrollbar {
          width: 0;
        }

        .request-loading-error {
          width: 12.2rem;
          aspect-ratio: 303/485;
          background-size: 100%;
          background-repeat: no-repeat;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: url(~@/assets/img/doHomework/loading-error.png);
        }
      }

      .btn-area {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        min-height: 9rem;

        .upload-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .btn-item {
          width: 14rem;
          aspect-ratio: 280/76;
          background-size: 100%;
          background-repeat: no-repeat;
          color: #FFF;
          font-size: 1.3rem;
          text-align: center;
          cursor: pointer;
          display: flex;
          align-items: center;
          letter-spacing: 4px;
          justify-content: center;

          ::v-deep .el-upload {
            color: white;
            font-size: 1.3rem;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          ::v-deep .el-upload:focus {
            color: white;
            font-size: 1.3rem;
          }
        }

        .upload-tip {
          margin-top: 0.6rem;
          font-size: 0.9rem;
          line-height: 1.4;
          color: #81FEFF;
          text-align: center;
        }

        .btn-active {
          background-image: url(~@/assets/img/doHomework/zc.png);
        }

        .btn-inactive {
          background-image: url(~@/assets/img/doHomework/zhihui.png);
          cursor: no-drop;
        }
      }
    }
  }
}
</style>
